import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { useMessageEvent } from '@post-office/message-lifecycle';

export const useHandleDismiss = ({
	onDismissed,
}: {
	onDismissed: () => void;
}): {
	handleDismiss: () => void;
} => {
	const { messageInstanceClicked } = useMessageInstanceEvent();
	const { messageDismissed } = useMessageEvent();

	const handleDismiss = (): void => {
		void messageInstanceClicked({
			messageEventType: 'clicked',
			clickedElement: {
				clickIdentifier: 'twc-sidenav-banner-dismiss',
				clickedElement: 'button',
				buttonType: 'secondary',
			},
			action: {
				actionType: 'dismiss',
			},
			additionalMetadataFromFrontend: {},
		});
		void messageDismissed();
		onDismissed();
	};

	return { handleDismiss };
};
